import React from 'react';
import styled from 'styled-components';
import { Spinner } from 'reactstrap';

export const Container = styled.div`
  padding: 5px;
  margin-bottom: 10px;
  & > * {
    margin-bottom: 10px;
  }
  @media (min-width: 376px) {
    padding-top: 20px;
    padding-bottom: 20px;
    max-width: 1100px;
    margin: 0 auto;
    margin-bottom: 80px;
  }
`;

const Loading = props => {
  return (
    <Container>
      <Spinner type='grow' color='primary' />
      <Spinner type='grow' color='secondary' />
      <Spinner type='grow' color='success' />
      <Spinner type='grow' color='danger' />
      <Spinner type='grow' color='warning' />
      <Spinner type='grow' color='info' />
      <Spinner type='grow' color='light' />
      <Spinner type='grow' color='dark' />
    </Container>
  );
};

export default Loading;
